export default __webpack_public_path__ + "static/media/img4.14207c88.png";